import { connect } from 'react-redux';
import { IState } from '../../store';

import { BtiDistrictRating, IBtiDistrictRatingProps } from './index';

function mapStateToProps(state: IState): IBtiDistrictRatingProps {
  return {
    ratingLocation:
      (state.offerData.bti && state.offerData.bti.houseData && state.offerData.bti.houseData.ratingLocation) || null,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BtiDistrictRatingContainer = connect<IBtiDistrictRatingProps, any, any>(mapStateToProps)(
  BtiDistrictRating,
);
